import React from 'react';
import styles from './topicCard.module.css'
import {useSelector} from "react-redux";
import {getDocketTopicsAPI} from "../../../api/docketAPI";

const TopicSection = ({
                          topic,
                          friendlyName,
                          children,
                          isRider,
                          selectedTopics,
                          toggleSelectedTopicFunc,
                          isPaused = false,
                          useSentiment = true
                      }) => {

    const getTopicSentiment = (topic) => {
        if (topic in selectedTopics) {
            return selectedTopics[topic]["sentiment"]
        }

        return -100
    }

    const getSubtopicSentiment = (subtopic) => {
        if (topic in selectedTopics) {
            if (subtopic in selectedTopics[topic]["children"]) {
                return selectedTopics[topic]["children"][subtopic]
            }
            return -100
        }

        return -100
    }

    const toggleOnTopicDivClick = (topic, shouldUseSentiment, isRider) => {
        if (isPaused) {
            return
        }

        toggleSelectedTopicFunc(topic, "", -99)
    }

    const toggleOnSubtopicDivClick = (topic, subtopic, shouldUseSentiment) => {
        if (isPaused) {
            return
        }

        toggleSelectedTopicFunc(topic, subtopic, -99)
    }

    return (
        <div className={styles.topicSection}>
            <div
                 onClick={() => toggleOnTopicDivClick(topic, useSentiment, isRider)}
                 className={`${styles.topicRow} ${isRider ? styles.rider : undefined} ${getTopicSentiment(topic) !== -100 && styles.selected}`}>
                <p>{isRider ? "**" : ""}{friendlyName}</p>
            </div>
            {
                getTopicSentiment(topic) !== -100 &&
                children.map((child) => (
                    <div key={child[0]}
                         onClick={() => toggleOnSubtopicDivClick(topic, child[0], useSentiment)}
                         className={`${styles.subtopicRow} ${topic in selectedTopics ? undefined : styles.subtopicDisabled} ${getSubtopicSentiment(child[0]) !== -100 && styles.selected}`}>
                        <p>{child[1]}</p>
                    </div>
                ))
            }
        </div>
    )
}

const TopicCard = ({selectedTopics, toggleSelectedTopicFunc, isPaused, useSentiment = true}) => {

    const [docketTopics, setDocketTopics] = React.useState({});

    const jwt = useSelector((state) => state.user.jwt);
    const docket = useSelector((state) => state.navigation.currentDocket);

    React.useEffect(() => {
        getDocketTopicsAPI(jwt, docket).then(r => setDocketTopics(r))
    }, [jwt, docket])

    return (
        <div className={styles.wrapper}>
            {
                Object.keys(docketTopics).map((key, index) => (
                    <TopicSection useSentiment={useSentiment} key={key} selectedTopics={selectedTopics} topic={key}
                                  isPaused={isPaused}
                                  toggleSelectedTopicFunc={toggleSelectedTopicFunc}
                                  friendlyName={docketTopics[key]["name"]} children={docketTopics[key]["children"]}
                                  isRider={docketTopics[key]["isRider"]}/>
                    )
                )
            }
        </div>
    );
};

export default TopicCard;